module.exports = __webpack_public_path__ + "static/img/bg.095f061e.webp";